module.exports = __webpack_public_path__ + "media/stylesheets/images/mattrz_lp/logos/logo-16-9b0d82e01abc31d82bf1a987e07a31b9.png";